import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(_component_q_btn, _mergeProps({
    label: "Mark all as read",
    color: "primary",
    loading: _ctx.isLoading
  }, _ctx.$attrs, {
    dense: "",
    flat: "",
    "no-caps": "",
    onClick: _ctx.markAllRead
  }), null, 16, ["loading", "onClick"]))
}